import React from 'react'
import {StaticText} from '../../StaticText/StaticText'

interface IDetalhesProps {
    texto?: string
}

const Detalhes: React.FC<IDetalhesProps> = ({
    texto
}) => {

    if (!texto) return null

    return (
        <StaticText textSize='0.8em' textColor='var(--color-gray-2)'>
            {texto}
        </StaticText>
    )
}
  
export default Detalhes